import { __awaiter, __generator } from "tslib";
import { BarGraphKey } from './';
export var createBarGraphDriver = function (wrapper) {
    var base = wrapper.$("." + BarGraphKey);
    return {
        getBarsCount: function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
            return [2 /*return*/, base.$$('.recharts-bar-rectangle').count()];
        }); }); },
        getXAxisTickLable: function () { return base.$$('.xAxis .recharts-cartesian-axis-tick').text(); },
        getYAxisTickLable: function () { return base.$$('.yAxis .recharts-cartesian-axis-tick').get(0).text(); },
        base: base
    };
};
//# sourceMappingURL=driver.js.map